module.exports = __webpack_public_path__ + "media/images/game_icon/en/BC4071-af374dc065bec74c4bfe4f1c3d6aa77b.png";